import api from "./api";

const minutes = (html) => `${Math.max(2, Math.round((html || "").replace(/<[^>]+>/g, " ").split(/\s+/).length / 220))} min`;

// Article en base → format des cartes du blog.
export const toCard = (a) => ({
  slug: a.slug, title: a.title, category: a.category, date: a.publish_at, excerpt: a.summary,
  description: a.meta_description, readingTime: a.reading_minutes ? `${a.reading_minutes} min` : minutes(a.content_html), fromDb: true,
});

export const fetchDbArticles = () => api.get("/blog/articles").then((r) => (r.data || []).map(toCard)).catch(() => []);

export const wrapTables = (html) => (html || "").replace(/<table/g, '<div class="blog-table"><table').replace(/<\/table>/g, "</table></div>");

// Liens vers des articles du blog pas encore publiés : texte simple (pas de 404).
export const unlinkUnpublished = (html, liveSlugs) => (html || "").replace(
  /<a href="\/blog\/([a-z0-9-]+)[^"]*"[^>]*>([\s\S]*?)<\/a>/g,
  (m, slug, text) => (liveSlugs.has(slug) ? m : text),
);
